import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Row,
  Tabs,
  TimePicker,
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { NavBar } from '../../../compnents/nav/NavBar'
import {
  getPayMethodName,
  PayMethod,
  PayMethods,
} from '../../../models/payment'
import {
  Checks,
  MedicelListValue,
  payListValue,
  Settinglable,
  Settings,
} from '../../../models/setting'
import { setSettings } from '../../settings/settingsSlice'
import { TenentSettingModal } from './TenentSettingModal'
import {
  getMedicalSettingList,
  getSettingDetails,
  invoiceDetailAsync,
  saveTenentSettingLabel,
  selectTenentSettings,
  getPayList,
  getPayListYinlian,
  getPayListKanglin,
} from './TenentSettingSlice'
import styles from './TenantSetting.module.css'
import { InvoiceModal } from './invoiceModal'
import { TenentSettingPayModal } from './TenentSettingPayModal'
import { TenentSettingPayModalYinlian } from './TenentSettingPayModalYinlian'
import { TenentSettingPayModalKanglin } from './TenentSettingPayModalKanglin'

import { ReplaceMakeModal } from '../replaceMakeModal'
import { getTenantDetail, selectReplaceOpentype } from '../tenantSlice'
import { BaseSet } from './fileSet/baseSet'
import { Settlement } from './fileSet/settlement'
import { ValueAdded } from './fileSet/valueAdded'
import { TransferSettlement } from './fileSet/transferSettlement'

export const TenentSetting = (): ReactElement => {
  const { TabPane } = Tabs
  const dispatch = useDispatch<any>()

  const [form] = Form.useForm()

  const settings = useSelector(selectTenentSettings)

  console.log(settings, 'settings')

  const [settingVisible, setSettingVisible] = useState({
    id: 0,
    tenantId: location.search.replace('?', '') as any,
    visible: false,
  })
  const [invoiceVisible, setInvoiceVisible] = useState({
    id: 0,
    tenantId: location.search.replace('?', '') as any,
    visible: false,
  })

  // const [previewPayMethod, setPreviewPayMethod] = useState(PayMethod.Cash)

  const [medicalList, setMedicalList] = useState<MedicelListValue[]>([])

  const [payList, setPayList] = useState<any>() //米雅聚合支付
  const [payStatus, setpayStatus] = useState<any>() //米雅聚合支付字体样式
  const [payListYinlian, setPayListYinlian] = useState<any>() //银联聚合支付
  const [payListKanglin, setPayListKanglin] = useState<any>() //康邻聚合支付

  const [payStatusYinlian, setpayStatusYinlian] = useState<any>() //银联聚合支付字体样式
  const [payStatusKanglin, setpayStatusKanglin] = useState<any>() //康邻聚合支付字体样式

  const [invoiceOptions, setInvoiceOptions] = useState<any>([])

  const [zcShoperId, setzcShoperId] = useState<any>()

  const [settingPayVisible, setSettingPayVisible] = useState({
    id: 0,
    tenantId: location.search.replace('?', ''),
    visible: false,
  })

  const [settingPayVisibleYinlian, setSettingPayVisibleYinlian] = useState({
    id: 0,
    tenantId: location.search.replace('?', ''),
    visible: false,
  })

  const [settingPayVisibleKanglin, setSettingPayVisibleKanglin] = useState({
    id: 0,
    tenantId: location.search.replace('?', ''),
    visible: false,
  })
  // 代煎设置
  const [isReplaceMakeModalVisible, setIsReplaceMakeModalVisible] = useState(
    false
  )

  const [formStatus, setFormStatus] = useState(true)

  const [tabActive, setTabActive] = useState('0')

  const replaceMakeStatus = useSelector(selectReplaceOpentype)

  const MedicalList = async () => {
    await dispatch(
      getMedicalSettingList(Number(location.search.replace('?', '')))
    )
      .then(unwrapResult)
      .then((res: MedicelListValue[]) => {
        setMedicalList(res)
      })
  }

  // 聚合支付信息获取
  const payGetList = async () => {
    //米雅
    await dispatch(getPayList(location.search.replace('?', '')))
      .then(unwrapResult)
      .then((res: any) => {
        setPayList(res.chlMiyaVO)
        setpayStatus(res.openHubPay)
      })
    //银联
    await dispatch(getPayListYinlian(location.search.replace('?', '')))
      .then(unwrapResult)
      .then((res: any) => {
        setPayListYinlian(res.chlMiyaVO)
        setpayStatusYinlian(res.openHubPayYinlian)
      })
    //康邻
    await dispatch(getPayListKanglin(location.search.replace('?', '')))
      .then(unwrapResult)
      .then((res: any) => {
        setPayListKanglin(res.chlMiyaVO)
        setpayStatusKanglin(res.openHubPayKanglin)
      })
  }

  // useEffect(() => {
  //   if (settings) {
  //     const defaultMethod =
  //       (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
  //     setPreviewPayMethod(defaultMethod)
  //     dispatch(
  //       setSettings({
  //         [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
  //         [Settings.Payment.DefautMethod]: defaultMethod,
  //       })
  //     )
  //     const value = settings[Checks.Zdrjsj]
  //     form.setFieldsValue({
  //       ...settings,
  //       [Checks.QF]: !!settings[16],
  //       [Checks.Zdrjsj]:
  //         value === '' || value === undefined || value === 'Invadlid date'
  //           ? undefined
  //           : moment(value, 'HH:mm'),
  //     })
  //   }
  // }, [settings])

  const getInvoiceList = () => {
    const data = {
      tenantId: location.search.replace('?', ''),
      id: 0,
    }
    dispatch(invoiceDetailAsync(data))
      .then(unwrapResult)
      .then((res: any) => {
        setInvoiceOptions(res)
      })
  }

  // 医保险种列表
  useEffect(() => {
    MedicalList()
    getInvoiceList()
    payGetList()
  }, [])

  useEffect(() => {
    if (location.search.replace('?', '')) {
      MedicalList()
    }
  }, [location.search.replace('?', '')])

  useEffect(() => {
    const id = location.search.replace('?', '')
    dispatch(getSettingDetails({ tenantId: id }))
    getTenantDetails()
  }, [])

  const getTenantDetails = () => {
    dispatch(getTenantDetail(location.search.replace('?', '')))
      .then(unwrapResult)
      .then((v: any) => {
        setzcShoperId(v?.zcShoperId)
      })
  }

  const onSubmit = (data: any, zcShoperId?: any) => {
    const pattern = /^[0-9]*$/
    const f = _.chain(data)
      .pickBy((_, k) => pattern.test(k))
      .mapValues(
        (v, k) =>
          ({
            type: k,
            value:
              k === Checks.Zdrjsj.toString()
                ? moment(v).format('HH:mm:ss')
                : v?.toString(),
          } as Settinglable)
      )
      .values()
      .value()
    dispatch(
      saveTenentSettingLabel({
        tenant: {
          id: location.search.replace('?', ''),
          zcShoperId: zcShoperId,
        },
        functionList: f,
      }) as any
    )
      .then(unwrapResult)
      .then(() => {
        notification.success({
          message: '机构设置保存成功',
          duration: 3,
        })
        const id = location.search.replace('?', '')
        dispatch(getSettingDetails({ tenantId: id }))
        getTenantDetails()
        // form.resetFields()
      })
      .catch(() => {
        notification.error({
          message: '机构设置保存失败',
          duration: 3,
        })
        const id = location.search.replace('?', '')
        dispatch(getSettingDetails({ tenantId: id }))
        form.resetFields()
      })
      .finally(() => setFormStatus(true))
  }
  return (
    <>
      <NavBar
        style={{ margin: '10px 20px' }}
        where={['机构管理', '功能设定']}
        backtrace={{
          name: '返回机构用户',
          path: '/admin/tenant',
        }}
      />
      <div
        style={{
          position: 'relative',
          height: 'calc(100% - 70px)',
          margin: '10px 20px',
          display: 'flex',
          flexDirection: 'column',
          background: '#FFFFFF',
          borderRadius: '10px',
          // overflowY: 'scroll',
        }}
      >
        <div className={styles.tabWrap}>
          <Tabs
            activeKey={tabActive}
            onChange={(e) => {
              if (!formStatus) {
                notification.info({ message: '请保存当前页面修改！' })
                return
              }
              setTabActive(e)
            }}
          >
            <TabPane tab='基本功能设置' key='0'>
              <BaseSet
                formObj={settings}
                formChange={() => setFormStatus(false)}
                onSave={onSubmit}
              />
            </TabPane>
            <TabPane tab='结转设置' key='2'>
              <TransferSettlement
                formObj={settings}
                formChange={() => setFormStatus(false)}
                onSave={onSubmit}
              />
            </TabPane>
            <TabPane tab='结算设置' key='3'>
              <Settlement
                formObj={settings}
                formChange={() => setFormStatus(false)}
                onSave={onSubmit}
              />
            </TabPane>
            <TabPane tab='增值业务设置' key='4'>
              <ValueAdded
                zcShoperId={zcShoperId}
                payStatus={payStatus}
                payStatusYinlian={payStatusYinlian}
                payStatusKanglin={payStatusKanglin}
                replaceMakeStatus={replaceMakeStatus}
                payList={payList}
                payListYinlian={payListYinlian}
                payListKanglin={payListKanglin}
                invoiceOptions={invoiceOptions}
                medicalList={medicalList}
                formObj={settings}
                onSettingVisible={(data: any) => {
                  setSettingVisible(data)
                }}
                onSettingPayVisibleYinlian={(data: any) => {
                  setSettingPayVisibleYinlian(data)
                }}
                onSettingPayVisibleKanglin={(data: any) => {
                  setSettingPayVisibleKanglin(data)
                }}
                onInvoiceVisible={(data: any) => {
                  setInvoiceVisible(data)
                }}
                onSettingPayVisible={(data: any) => {
                  setSettingPayVisible(data)
                }}
                onIsReplaceMakeModalVisible={(data: any) => {
                  setIsReplaceMakeModalVisible(data)
                }}
                formChange={() => setFormStatus(false)}
                onSave={onSubmit}
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
      <TenentSettingModal
        id={settingVisible.id}
        tenantId={location.search.replace('?', '')}
        onOk={async () => {
          await setSettingVisible({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
          MedicalList()
        }}
        onCancel={() => {
          setSettingVisible({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
        }}
        visible={settingVisible.visible}
      />
      {/* 电子发票 */}
      <InvoiceModal
        id={invoiceVisible.id}
        tenantId={location.search.replace('?', '')}
        onOk={async () => {
          await setInvoiceVisible({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
          getInvoiceList()
        }}
        onCancel={() => {
          setInvoiceVisible({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
        }}
        visible={invoiceVisible.visible}
      />
      {/* 聚合支付 米雅*/}
      <TenentSettingPayModal
        id={settingPayVisible.id}
        tenantId={location.search.replace('?', '')}
        onOk={() => {
          setSettingPayVisible({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
          payGetList()
        }}
        onCancel={() => {
          setSettingPayVisible({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
        }}
        visible={settingPayVisible.visible}
      />

      {/* 聚合支付 银联*/}
      <TenentSettingPayModalYinlian
        id={settingPayVisibleYinlian.id}
        tenantId={location.search.replace('?', '')}
        onOk={() => {
          setSettingPayVisibleYinlian({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
          payGetList()
        }}
        onCancel={() => {
          setSettingPayVisibleYinlian({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
        }}
        visible={settingPayVisibleYinlian.visible}
      />
      {/* 聚合支付 银联*/}
      <TenentSettingPayModalKanglin
        id={settingPayVisibleKanglin.id}
        tenantId={location.search.replace('?', '')}
        onOk={() => {
          setSettingPayVisibleKanglin({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
          payGetList()
        }}
        onCancel={() => {
          setSettingPayVisibleKanglin({
            id: 0,
            tenantId: location.search.replace('?', ''),
            visible: false,
          })
        }}
        visible={settingPayVisibleKanglin.visible}
      />
      {/* 代煎 */}
      <ReplaceMakeModal
        replaceMakeId={location.search.replace('?', '') as any}
        // replaceMakeStatus={replaceMakeStatus}
        visible={isReplaceMakeModalVisible}
        onOk={() => {
          // dispatch(setReplaceId(0))
          // dispatch(setReplaceOpentype(0))
          setIsReplaceMakeModalVisible(false)
        }}
        onCancel={() => {
          setIsReplaceMakeModalVisible(false)
        }}
      />
    </>
  )
}
